// src/components/dev/utils/Spinner/Spinner.tsx
import React from "react";
import { Spin } from "antd";
import styled from "styled-components";

// Styled component for centering the spinner
const CenteredDiv = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;

  /* Style for the spinner dots (previously in Spinner.css) */
  .ant-spin-dot-item {
    background-color: gold; /* You can adjust the color here */
  }
`;

// Define the props interface (currently no props, but added for future extensibility)
interface SpinnerProps {}

// Functional component with TypeScript typing
const Spinner: React.FC<SpinnerProps> = () => (
  <CenteredDiv>
    <Spin size="large" />
  </CenteredDiv>
);

export default Spinner;